import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as graphql from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';

import BulkModal from './BulkModal';
import { Box, Flex } from 'reflexbox';
import { Checkbox, Label, Paragraph } from '@treams/treams-ui';

export default function BulkExportUserDataModal(props: {
	users: graphql.User[];
	onDismiss: () => void;
}) {
	const { t } = useTranslation();
	const { language } = useLocalize();

	const [exportData] = graphql.useExportUserDataMutation();

	const [types, setTypes] = useState<graphql.UserExportType[]>(
		Object.values(graphql.UserExportType),
	);

	return (
		<BulkModal
			name="bulkExportData"
			valid
			apply={async (user) => {}}
			applySingle={async (users) => {
				await exportData({
					variables: {
						input: {
							languageID: language.id,
							userIDs: users.map((user) => user.id),
							types,
						},
					},
				});
			}}
			users={props.users}
			onDismiss={props.onDismiss}
		>
			<Paragraph mb={4}>{t('employees.bulkExportData.instructions')}</Paragraph>
			<Box mb={4}>
				<Label mb={2}>{t('employees.bulkExportData.types.label')}</Label>
				{Object.values(graphql.UserExportType).map((type) => (
					<Flex
						key={type}
						mb={2}
						alignItems="center"
						onClick={() => {
							if (types.includes(type)) {
								setTypes(types.filter((needle) => needle !== type));
								return;
							}
							setTypes(types.concat([type]));
						}}
					>
						<Checkbox checked={types.includes(type)} />
						<Label ml={2}>{t(`employees.bulkExportData.type.${type}`)}</Label>
					</Flex>
				))}
			</Box>
		</BulkModal>
	);
}
